<template>
    <div>
        <b-datatable
            :key="datatableKey"
            v-model="selectedPharmacySites"
            :columns="columns"
            :endpoint="listRoute"
            :hidden-columns="hiddenColumns"
            has-filter-selector
            :grid-title="t('pharmacy-sites::page.title.pharmacy_sites')"
            item-key="id"
            hide-page-configurator
            v-bind="$attrs"
            :selected-items="selectedPharmacySites"
            :disabled-select="disabled"
            :has-bulk-operations="!previewMode"
            :preview-mode="previewMode"
            :initial-filters="initialFilters"
            :keep-filters="false"
            v-on="$listeners"
        >
            <template #bulkOperations>
                <v-btn color="primary" small rounded outlined @click="previewMode = !previewMode">
                    {{ previewMode ? t('default::button.view.all') : t('default::button.view.selected') }}
                </v-btn>
            </template>
            <template #filters="{ filters }">
                <v-col cols="4" class="pb-0">
                    <b-filter-input
                        v-model="filters.filters.site_name"
                        :label="t('pharmacy-sites::label.site_name')"
                    ></b-filter-input>
                </v-col>
                <v-col cols="4" class="pb-0">
                    <b-filter-input
                        v-model="filters.filters.dms_id"
                        :label="t('pharmacy-sites::label.dms_id')"
                    ></b-filter-input>
                </v-col>
                <v-col cols="4" class="pb-0">
                    <b-filter-select
                        v-model="filters.filters.is_registered"
                        :items="filtersOptions.is_registered"
                        :label="t('consultants::label.registered')"
                        :clearable="filters.filters.is_registered !== null"
                    >
                    </b-filter-select>
                </v-col>
            </template>

            <template #[`item.is_registered`]="{ item }">
                <div class="grid-status">
                    <span>
                        {{ item.is_registered ? t('default::label.yes') : t('default::label.no') }}
                    </span>
                </div>
            </template>

            <template #[`item.pharmacy_groups`]="{ item }">
                <span v-for="(value, key) in item.pharmacy_groups" :key="key">
                    {{ value.group_name }}
                </span>
            </template>

            <template #[`item.actions`]="{ item }">
                <div class="table-actions">
                    <v-tooltip v-if="can('api.v1.pharmacy-sites.show')" top>
                        <template #activator="{ on, attrs }">
                            <v-btn
                                color="disabled-color"
                                icon
                                v-bind="attrs"
                                v-on="on"
                                @click="$root.goTo(itemUrl(item), true)"
                            >
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('pharmacy-sites::button.details') }}</span>
                    </v-tooltip>
                </div>
            </template>
        </b-datatable>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            previewMode: false,
            datatableKey: 0,
            initialFilters: {
                is_registered: null,
            },
            hiddenColumns: ['id', 'surname', 'chief_pharmacist_name'],
            columns: [
                {
                    text: t('default::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('pharmacy-sites::label.site_name'),
                    value: 'site_name',
                    sortable: true,
                    width: 200,
                },
                {
                    text: t('pharmacy-sites::label.registered'),
                    value: 'is_registered',
                    sortable: true,
                    width: 140,
                },
                {
                    text: t('pharmacy-sites::label.pharmacy_groups'),
                    value: 'pharmacy_groups',
                    sortable: false,
                    width: 180,
                },
                {
                    text: t('pharmacy-sites::label.chief_pharmacist_name'),
                    value: 'chief_pharmacist_name',
                    sortable: true,
                    width: 180,
                },
                {
                    text: t('pharmacy-sites::label.dms_id'),
                    value: 'dms_id',
                    width: 140,
                    sortable: true,
                },
                {
                    text: t('default::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: 'count_active_patients',
                    align: 'end',
                    width: 180,
                },
            ],
            filtersOptions: {
                is_registered: [
                    {
                        text: t('default::options.all'),
                        value: null,
                    },
                    {
                        text: t('default::options.yes'),
                        value: 1,
                    },
                    {
                        text: t('default::options.no'),
                        value: 0,
                    },
                ],
            },
        };
    },
    computed: {
        id() {
            const id = this.$store.state.pharmacy_groups.pharmacy_group.id;
            if (id && this.selectedPharmacySites && this.selectedPharmacySites.length) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.previewMode = true;
                return id;
            }
            return id;
        },
        selectedPharmacySites: {
            get() {
                return this.$store.state.pharmacy_groups.pharmacy_group.pharmacy_sites;
            },
            set(value) {
                value = value.map((element) => ({ id: element.id }));
                if (value.length) {
                    this.$store.dispatch(`pharmacy_groups/updateProperty`, {
                        value: value,
                        property: 'pharmacy_group.pharmacy_sites',
                    });
                }
            },
        },
    },
    mounted() {
        this.id;
    },
    methods: {
        itemUrl(item) {
            let itemUrl = route('pharmacy-sites.get', { id: item.id });
            itemUrl += `?preview=true`;
            return itemUrl;
        },
    },
};
</script>
